import { createGridLayout, createGridItem } from "../../../../store/global/gridlayout";
export const bookingPromotersState = {
    bookingPromoters: [],
    contactsForPromoter: [],
    clientDisplayName: "",
    bookingPromoterSelected: {},
    bookingPromoterSelectedOverView: {},
    bookingPromoterSelectedBookings: {},
    bookingPromoterSelectedAdditionalInfo: {},
    bookingPromoterSideWindowSelectedTab: "",
    routeQueryModal: "",
    isSelectedPromoterLoading: true,
    bookingPromoterDetailGridLayouts: createGridLayout({
        layout: [
            createGridItem({
                x: 0,
                y: 0,
                w: 30,
                h: 18,
                i: 'contact',
            }),
            createGridItem({
                x: 30,
                y: 0,
                w: 30,
                h: 18,
                i: 'communication_info',
            }),
            createGridItem({
                x: 0,
                y: 36,
                w: 60,
                h: 12,
                i: 'related_contacts',
            }),
            createGridItem({
                x: 0,
                y: 48,
                w: 30,
                h: 12,
                i: 'notes',
            }),
            createGridItem({
                x: 30,
                y: 48,
                w: 30,
                h: 12,
                i: 'public_comments_list',
            }),
            createGridItem({
                isResizable: false,
                x: 0,
                y: 60,
                w: 60,
                h: 5,
                i: 'promoter_tab_booking_section',
            }),
            createGridItem({
                x: 0,
                y: 65,
                w: 60,
                h: 30,
                i: 'bookings',
            }),
            createGridItem({
                isResizable: false,
                x: 0,
                y: 95,
                w: 60,
                h: 5,
                i: 'promoter_tab_additional_info_section',
            }),
            createGridItem({
                x: 0,
                y: 100,
                w: 30,
                h: 30,
                i: 'custom_field',
            }),
            createGridItem({
                x: 30,
                y: 100,
                w: 30,
                h: 30,
                i: 'related_documents',
            }),
        ]
    }),
    promoters_list_start_from: 0,
    add_promoter_contact_list_start_from: 0,
    promoterDetails: [],
};